import { render, staticRenderFns } from "./result-review-score.vue?vue&type=template&id=8fa8d9da&scoped=true&"
import script from "./result-review-score.vue?vue&type=script&lang=js&"
export * from "./result-review-score.vue?vue&type=script&lang=js&"
import style0 from "./result-review-score.vue?vue&type=style&index=0&id=8fa8d9da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa8d9da",
  null
  
)

export default component.exports